// Module
var code = "<script id=\"wcc-components-spinner-new\" type=\"text/template\"></script>";
// Exports
module.exports = code;